import axios from 'axios';

export let apiAuth;
export let apiPublic;
export let axiosInitPromise;

// Immediately invoke an async function to initialize Axios instances
axiosInitPromise = (async () => {
    // const baseUrl = process.env.REACT_APP_API_URL; // Get the base URL from environment variable
    const baseUrl = window.Links.ApiURL;

    // Axios instance for requests that require credentials
    apiAuth = axios.create({
        baseURL: baseUrl,
        //withCredentials: true, // Include credentials (cookies) with requests
        // This setting prevents Axios from treating non-2xx status codes as errors
        validateStatus: function (status) {
            return true; // Always return true to handle all status codes in the then() block
        }
    });

    // Axios instance for requests that do not require credentials
    apiPublic = axios.create({
        baseURL: baseUrl,
        // No withCredentials option
        // This setting prevents Axios from treating non-2xx status codes as errors
        validateStatus: function (status) {
            return true; // Always return true to handle all status codes in the then() block
        }
    });

    console.log('Axios instances initialized');
})();


